/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductCardGrid from "@stoneage/App/Components/ProductCards/ProductCardGrid";
import React, { FC } from "react";
import { connect, ConnectedProps } from "react-redux";

type Props = ProductCardSelections & HasProduct & PropsFromRedux & { view: "List" | "Grid" };

const mapStateToProps = (state: ApplicationState) => {
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    const userName = state.context.session.userName;

    return {
        isAuthenticated: userName && !currentUserIsGuest,
    };
};

const ProductListProductGridCard: FC<Props> = ({
    product,
    productInfo,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showPartNumbers,
    showTitle,
    showPrice,
    isAuthenticated,
    view,
}) => (
    <ProductCardGrid
        product={product}
        productInfo={productInfo}
        showImage={showImage}
        showCompare={showCompare}
        showAttributes={showAttributes}
        showAvailability={showAvailability}
        showPartNumbers={showPartNumbers}
        showTitle={showTitle}
        showPrice={showPrice}
        showAddToCart={true}
        isAuthenticated={isAuthenticated}
        view={view}
    />
);

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(withProduct(ProductListProductGridCard));
